import React, { useEffect, useMemo, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from '../../UI/Card/Card';
import Graybg from '../../UI/Graybg';
import SecBTN from '../../UI/SecBTN';
import classes from './DeletePaper.module.css'
import { Link } from 'react-router-dom';
import userService from '../../app/services/user.service';
import { toast } from 'react-toastify';
import Loader from '../../UI/loader/loader';
import { isEmpty } from '../../utils/custom_funtions';
import SmallLoader from '../../UI/SmallLoader/SmallLoader';
import SuccessModal from '../../UI/SuccessModal/SuccessModal';
import ConfirmationModal from '../../UI/ConfirmationModal/ConfirmationModal';
import Toast from '../../UI/Toast/Toast';
import SearchInput from '../../UI/SearchInput/SearchInput';


const DeletePaper = () => {
  const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
  const listCount = 50;
  const [loading, setLoading] = useState(false);
  const [pendingData, setPendingData] = useState([]);
  const [pageNo, setPageNo] = useState(0);
  const [search, setSearch] = useState('');
  const [loadMore, setloadMore] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [showPopUp1,setShowPopUp1] = useState({show:false, pid:""})
  const [showPopUp2,setShowPopUp2] = useState(false)
  const deleteHandler = (pid) => {
    setShowPopUp1({show:true, pid:pid})
  } 
  const yesHandler = () => {
    setLoading(true)
    userService.deletePaperReq(showPopUp1.pid)
    .then(res => {
      console.log(res)
      setLoading(false)
      setShowPopUp1({show:false, pid:""})
      setShowPopUp2(true)
      pendingPaperFn()
    })
    .catch(err => {
      setLoading(false)
      console.log(err)
      setShowPopUp1({show:false, pid:""})
      if(err.response.status === 500){
        toast.error(err.response.data.message);
      } else {
        toast.error("Something went wrong !!");
      }
    })
  } 
  const onHideHandler = () => {
    setShowPopUp1({show:false, pid:""})
    setShowPopUp2(false)
  }
  const pendingPaperFn = () => {
    setLoading(true)
    userService
      .getReqpaperList()
      .then((data) => {
        // if (data.data.data.length < 50) {
        //   setloadMore(false);
        // }
        setLoading(false);
        // setPendingData(data.data.data);
        // console.log([...data.data.data[0]])
        let datas = data.data.data[0]
        let newArr = []; 
        for (const i in datas){
          if(datas[i].status == 1){
            const object = datas[i];
            newArr.push(object) 
          }
        }
          setPendingData(newArr)
      })
      .catch((error) => {
        setLoading(false);
        console.log("error", error);
        toast.error(error.message);
      });
  };
  
  useEffect(() => {
      
        pendingPaperFn();
      
    
  }, []);
  const searchedData = useMemo(() => {
    // let computedData = pendingData;
    if(search){
      return pendingData.filter(data => data.paper_name.toLowerCase().includes(search.toLowerCase()))
    } else {
      return pendingData
    }
  },[search,pendingData]);

  return (
    <div className="section">
    {loading && <Loader />}
    <Toast />
    <ConfirmationModal
        title="Are you sure you want to DELETE this paper?"
        show={showPopUp1.show}
        onHide={onHideHandler}
        yesHandler={yesHandler}
        confirmTxt="yes"
      />
      <SuccessModal 
        show={showPopUp2}
        onHide={onHideHandler}
        title="Paper Deleted Successfully!"
        btnTxt="Ok"
      />
    <div className="d-flex justify-content-between align-items-center">
      <div>
      <h4>Delete Paper</h4>
      <Breadcrumb>
        <Breadcrumb.Item active>Delete Paper</Breadcrumb.Item>
      </Breadcrumb>
      </div>
      <div className='d-flex gap-3 align-items-center mb-3'>
      <SearchInput value={search} onChange={e => setSearch(e.target.value)}/>
      <div className={`d-flex justify-content-center align-items-center gap-3 ${classes.btnsec}`}>
          <SecBTN className='sec-btn me-0' disabled={pageNo == 0} onClick={() => setPageNo(pageNo-1)}><i className="fa-solid fa-arrow-left"></i></SecBTN>
          <p style={{width:"60px"}} className='text-center' > {`${Math.ceil(searchedData.length/50) == 0 ? 0 :pageNo+1} / ${Math.ceil(searchedData.length/50)}`}
          </p>
          <SecBTN className='sec-btn' disabled={pageNo+1 == Math.ceil(searchedData.length/50) || Math.ceil(searchedData.length/50) == 0} onClick={() => setPageNo(pageNo+1)}><i className="fa-solid fa-arrow-right"></i></SecBTN>
        </div>
        </div>
    </div>
      <Graybg>
        {
          isEmpty(searchedData) ? (
            !loading &&
            <p className="text-center">No data available.</p>
          ) : (
            searchedData.slice(listCount*pageNo,(pageNo+1)*listCount).map((data, i) => (
              <Card>
      <Row>
        <Col lg={10} md={8} sm={12}>
          <h5>
            {data.paper_name}
          </h5>
          <Row>
            <Col lg={8} md={6} sm={12}>
              <p>Class : {data.class}</p>
              {/* <p>Subject : {props.subject}</p> */}
              <p>Target : {data.target}</p>
              <p>Format : {data.format}</p>
              <p>Questions Assigned by : {data.creator}</p>
            </Col>
            <Col lg={4} md={6} sm={12}>
              <p>Assigned on : {new Date(data.created_on).toLocaleDateString("sv-SE")}</p> 
              <p>Exam Date : {data.to_be_held_on}</p>
              <p>Date Of Submission : {data.to_be_completed_by}</p>
              {/* <p>Date Of Finalization : {props.date_finalization}</p> */}
            </Col>
          </Row>
        </Col>
        <Col lg={2} md={4} sm={12} className="text-end">
          {/* <Link to={ props.paperPending ? "/createPaper/paperMatrix" : `/createPaper/paperMatrix/${props.uid}/${props.sid}/${props.pid}`}> */}
          
            <SecBTN className={classes["delpaper-btn"]} onClick={() => deleteHandler(data.pid)}>
              Delete Paper
            </SecBTN>
          
        </Col>
      </Row>
    </Card>
            )
            )
          )
        }
        {/* {(loadMore && !loading) && (
        <div className="text-center my-4">
          <SecBTN
            className={`${classes.btn} sec-btn1`}
            onClick={loadMoreHandler1}
          >
            Load more
            {btnLoading && <SmallLoader />}
          </SecBTN>
        </div>
      )} */}
      </Graybg>
    </div>
  );
}

export default DeletePaper
